export default __webpack_public_path__ + "static/media/vital_risas.ffba9781.jpg";